import { Box, Typography } from '@mui/material'
import { MuiMarkdown } from 'mui-markdown'
import { markdownStyles } from 'src/v3/utilities/markdown-styles'
import {
  CourseV2ShowNotesStep,
  ShowNotesBlock,
  ShowNotesImageBlock,
  ShowNotesPDFBlock,
  ShowNotesTextBlock,
} from 'src/v3/classroom-v2/types'
import { PDFBlockViewer } from 'src/v3/classroom-v2/components/pdf-viewer'

let renderBlock = (courseID: string, block: ShowNotesBlock) => {
  if (block.kind === 'textBlock') {
    let textBlock = block as ShowNotesTextBlock
    return (
      <Box key={block.id} sx={{ mb: 3 }}>
        <Box sx={markdownStyles}>
          <MuiMarkdown>{textBlock.markdown || ''}</MuiMarkdown>
        </Box>
      </Box>
    )
  }

  if (block.kind === 'pdfBlock') {
    let pdfBlock = block as ShowNotesPDFBlock
    if (!pdfBlock.pdfUrl) return null
    return (
      <Box key={block.id} sx={{ mb: 4 }}>
        <PDFBlockViewer courseID={courseID} block={pdfBlock} />
      </Box>
    )
  }

  let imageBlock = block as ShowNotesImageBlock
  if (!imageBlock.imageUrl) return null

  return (
    <Box key={block.id} sx={{ mb: 4, textAlign: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: imageBlock.caption ? 2 : 0,
        }}
      >
        <img
          src={`${import.meta.env.VITE_CLOUDFRONT_URL}/images/${imageBlock.imageUrl.replace('originals', 'resized')}`}
          alt={imageBlock.altText || imageBlock.caption || 'Article image'}
          style={{
            width: `${imageBlock.widthPercent || 100}%`,
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        />
      </Box>
      {imageBlock.caption && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontStyle: 'italic',
            textAlign: 'center',
            maxWidth: '80%',
            mx: 'auto',
            lineHeight: 1.5,
          }}
        >
          {imageBlock.caption}
        </Typography>
      )}
    </Box>
  )
}

export let ShowNotesStep = ({
  courseID,
  step,
}: {
  courseID: string
  step: CourseV2ShowNotesStep
}) => (
  <Box
    sx={{
      maxWidth: '900px',
      mx: 'auto',
      '& > *:first-of-type': { mt: 0 },
      '& > *:last-child': { mb: 0 },
    }}
  >
    {step.blocks
      .toSorted((a, b) => a.sequence - b.sequence)
      .map((block) => renderBlock(courseID, block))}
  </Box>
)
